var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLightProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 13.1033C25.38 11.7478 22.0233 9.33337 18.6667 9.33337C14 9.33337 7 14 7 14V46.6667C7 46.6667 14 42 18.6667 42C22.0233 42 25.38 44.4144 27 45.7699V13.1033ZM29 45.7203C31.7774 43.2407 34.5563 42 37.3333 42C40.4437 42 44.3333 43.5564 49 46.6667V14C44.3333 10.8897 40.4437 9.33337 37.3333 9.33337C34.5563 9.33337 31.7774 10.574 29 13.0537V45.7203Z",
    fill: "#F1B007"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightProgram);
export default __webpack_public_path__ + "static/media/icon_light_program.3132a81ad7165c6f962129850c99537a.svg";
export { ForwardRef as ReactComponent };